import { CartItem } from "../types/checkoutTypes"
import { CartProduct } from "../../ts/interfaces"
import { getCartProduct } from "../../utils/stripejs"

export const isHeadset = (product: CartProduct | null): boolean => {
  return (
    product !== null &&
    (product.metadata.bladeSKU === "SEN_HEADSET_V1" ||
      product.metadata.bladeSKU === "SEN_HEADSET_V1.5" ||
      product.metadata.bladeSKU === "SEN_HEADSET_OPENV1" ||
      product.metadata.bladeSKU === "SEN_HEADSET_OPENV1.5" ||
      product.metadata.bladeSKU === "SEN_HEADSET_REFURBV1")
  )
}

export const isHeadsetInCart = (cartItems: CartItem[]): boolean => {
  return cartItems.some(item => isHeadset(getCartProduct(item.productId)))
}
